import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Box,
  Checkbox,
  AppBar,
  Toolbar,
  Typography,
  InputAdornment,
  Tooltip,
} from "@material-ui/core";
import { API_URL } from "../../constants/api";
import { apiPost, apiRequest } from "../../utils/api_service";
import { ShowToast, toastType } from "../../utils/toast-service";
import {
  PaperComponent,
  removeDuplicates,
  GetUserConfiguration,
  GetUserName,
  GetUserEmail,
} from "../../utils/helper";
import "./communication.less";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { validateInput } from "../../utils/validations";
import EditorConvertToHTML from "../../components/common/Editor/HtmlEditor";
import ChevronRightIcon from "@material-ui/icons//ChevronRight";
import ChevronDownIcon from "@material-ui/icons//KeyboardArrowDown";
import SearchIcon from "@material-ui/icons/Search";
import { SECTIONS, maxFileSize, maxZipFileSize } from "../../constants/appConstants";
import commonLabels from "../../constants/messageConstants";
import {
  InfoOutlined,
} from "@material-ui/icons";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import FileUpload from "./FileUpload";
import FileAttachments from "../common/sharepoint-upload/file-attachments";
import DialogModal from "../common/DialogModal/Dialog";
import { convertToLocalDate } from "../../utils/date";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";
import _ from "lodash";

/**
 * React Component for Add update Mass Communication
 */
class AddUpdateCommunication extends React.Component {
  constructor(props) {
    super(props);
    let emailMessage = this.props?.content?.emailMessage?.replace(
      "<p>Dear Tenant,</p>",
      ""
    );
    emailMessage =
      emailMessage && emailMessage.length > 0
        ? emailMessage.substring(
          0,
          emailMessage.indexOf("<remove/>") > 0
            ? emailMessage.indexOf("<remove/>")
            : emailMessage.length - 1
        )
        : "";
    // Setting State based on Props
    const unCollapsed = [];
    if ((this.props.reply === true || this.props?.content != undefined)) {
      this.getGroupedData(this.props?.content?.emailRecipients, "name")?.forEach((obj) => {
        unCollapsed.push({ dc: obj.value, value: obj.value });
        this.getGroupedData(obj.data, "tenantName")?.forEach((ten) => {
          unCollapsed.push({ dc: obj.value, value: ten.value });

        });
      }
      )
    }

    this.state = {
      attachment: this.props?.content?.attachment || false,
      commCode: this.props?.content?.communicationCode || null,
      requesterEmailID: this.props?.content?.requesterEmailID || null,
      selectedRecipient: [],
      finalSelectedRecipient: this.props?.content?.emailRecipients || [],
      groupOriginalRecipient: this.props?.content?.emailRecipients || [],
      unCollapsed: unCollapsed,
      searchTenantText: "",
      subject: this.props?.content?.emailSubject,
      content: this.props.reply === true ? "" : emailMessage,
      communicationCode: this.props?.content?.communicationCode,
      isViewOnly: this.props?.content != undefined,
      isReply: this.props.reply || false,
      isCreate: this.props.isCreate || false,
      initialBodyText: "<p>Dear Tenant,</p>\n",
      signatureBodyText: `\n\n\n<remove/><div>Sincerely,</div>\n<div>${this.props?.content?.requesterEmailID && this.props.reply !== true
        ? this.props?.content?.requesterEmailID
        : GetUserName() || ""
        }</div>`,
      getToolTip: [],
      fileName: [],
      formData: [],
      reload: false,
      fileSize: 0,
      communicationLogType: this.props?.content?.communicationLogType,
      emailSentDateTime: this.props?.content?.emailSentDateTime,
    };
  }

  /** Component Did mount Call when first time component loads */
  componentDidMount() {
    this.getTooltip();
    if (!this.state.isViewOnly) {
      // Getting Master Tenant contact List
      this.getCommunicationLogMasterRecipient();
    }
  }

  /**
   * Submit Communication Data with files to Server
   * @param {*} data form data collection with Files
   */
  onSubmit = (data) => {
    apiPost({
      url: API_URL.Communication.CreateCommunicationLog,
      postBody: data,
    }).then(({ success: isExecuted }) => {
      if (isExecuted == true) {
        ShowToast(
          "Communication sent successfully.",
          toastType.SUCCESS,
          5000,
          200
        );
        this.props.onClose(false);
      } else
        ShowToast(
          commonLabels.somethingWrong.message,
          toastType.ERROR,
          5000,
          commonLabels.somethingWrong.code
        );
    });
  };

  /**
   * On Confirm prepare data and submit to server
   * @returns 
   */
  onSubmitConfirm = () => {
    const {
      finalSelectedRecipient,
      subject,
      content,
      initialBodyText,
      signatureBodyText,
      fileSize,
      commCode
    } = this.state;
    if (fileSize > maxZipFileSize) {
      ShowToast(
        "File size exceeded maximum limit of 29mb, file will not be sent. Either reduce size or remove some file.",
        toastType.ERROR,
        5000,
        200
      );
      return;
    }
    else {
      //setting form data
      const emailBody = new FormData();
      emailBody.append("RequesterEmailID", GetUserEmail())
      emailBody.append("Attachment", this.state.formData.length > 0 ? true : false);
      emailBody.append("FileSize", fileSize);
      emailBody.append("EmailSubject", subject);
      emailBody.append("CommunicationCode", commCode === null ? "" : commCode);
      emailBody.append(
        "EmailMessage",
        `${initialBodyText}${content}${signatureBodyText}`
      );

      emailBody.append(
        "EmailRecipients",
        JSON.stringify(finalSelectedRecipient)
      );
     
      for (let i = 0; i < this.state.formData.length; i++) {
        emailBody.append("File", this.state.formData[i]);
      }

      const emailBodyForValidation = {
        emailSubject: subject,
        emailMessage: content
          ? content
            .trim()
            .replaceAll("&nbsp;", "")
            .replaceAll("<p></p>", "")
            .replaceAll("\n", "")
          : "",
        emailRecipients: finalSelectedRecipient,
      };

      // Validation Config
      const validation = [
        {
          valueKey: "emailSubject",
          type: "text",
          isRequired: true,
          fieldsName: "Subject",
        },
        {
          valueKey: "emailMessage",
          type: "text",
          isRequired: true,
          fieldsName: "Email Body",
        },
        {
          valueKey: "emailRecipients",
          type: "array",
          isRequired: true,
          fieldsName: "Recipients",
        },
      ];

      // Validating
      if (validateInput(emailBodyForValidation, validation)) {
        this.onSubmit(emailBody);

        // this.setState({ isCloseSaveConfirm: true });
      }
    }
  };

  /**
   * Handles Recipient Change and update state
   * @param {*} key 
   * @param {*} data 
   * @param {*} event 
   * @param {*} dc 
   * @param {*} dataCenter 
   * @param {*} tenant 
   */
  handleRecipientChange = (key, data, event, dc, obj, ten, value) => {
    let { selectedRecipient, finalSelectedRecipient } = this.state;
    // if checkbox is checked add to finalSelectedRecipient else remove
    if (event.target.checked) {
      data?.data?.forEach((y) => {
        if (
          (key !== "tenantEmail"  && finalSelectedRecipient.find(
            (x) =>
             (x.name == y.name &&
              x.tenantName === y.tenantName &&
              x.email === y.email)
          ) === undefined) ||
          (key === "tenantEmail" && finalSelectedRecipient.find(
            (x) =>  x.name == y.name &&
              x.tenantName === y.tenantName &&
              x.email === value
          ) === undefined && y.email === value)) {
            selectedRecipient.push({
              dc: dc,
              value: key !== "tenantEmail" ? y.email : value,
              tenantName: y["tenantName"],
            });
            finalSelectedRecipient.push(y);
        }
      });
    } else {
      data?.data?.forEach((y) => {
        if (key !== "tenantEmail") {
          finalSelectedRecipient = finalSelectedRecipient.filter(
            (x) =>
              !(
                (x.name == y.name &&
                x.tenantName === y.tenantName &&
                x.email === y.email)
              )
          );
          selectedRecipient = selectedRecipient.filter(
            (z) =>
              !(z.dc === y.name &&
                z.value === y.email &&
                z.tenantName === y["tenantName"]
              )
          );
        }
        else {
          finalSelectedRecipient =  finalSelectedRecipient.filter(
            (x) =>
              !( x.name == y.name &&
                x.tenantName === y.tenantName &&
                x.email === value
              )
          );
          selectedRecipient = selectedRecipient.filter(
            (z) =>
              !(
                key === "tenantEmail" && z.dc === y.name &&
                z.value === value &&
                z.tenantName === y["tenantName"]
              )
          );
        }
      });
    }
    this.setState({
      selectedRecipient: removeDuplicates(selectedRecipient),
      finalSelectedRecipient: removeDuplicates(finalSelectedRecipient),
    });
  };

  /**
   * Get Tooltip data from server for Communication Module
   */
  getTooltip = () => {
    apiRequest({
      url: API_URL.masterData.GetLabels,
      params: { sectionId: SECTIONS.SEND_COMMUNICATION },
    }).then(({ data: response }) => {
      this.setState({
        getToolTip: response,
      });
    });
  };

  /**
   * Method for getting Tenant Contact List based on Access Group Id
   */
  getCommunicationLogMasterRecipient = () => {
    const userDetails = GetUserConfiguration();
    const accessGroupId = userDetails?.groups[0].accessGroupId;
    if (accessGroupId) {
      apiRequest({
        url:
          API_URL.Communication.GetCommunicationLogMasterRecipient +
          "?accessGroupId=" +
          accessGroupId,
      }).then(({ data: groupRecipient }) => {

        this.setState({
          groupOriginalRecipient: [...groupRecipient]
        });
      });
    }
  };

  /**
   * Method to Group Data based on Key
   * @param {*} data 
   * @param {*} key 
   * @returns Grouped data based on key
   */
  getGroupedData = (data, key) => {
    return _.chain(data || [])
      .groupBy(key)
      .map(function (v, i) {
        return {
          key: key,
          value: (v[0] || [])[key],
          recordId: i,
          data: v,
        };
      })
      .value();
  };

  /**
   * Method for handling collapse behavior for Recipient List
   * @param {*} expand 
   * @param {*} dc 
   * @param {*} value 
   */
  handleCollapse = (expand, dc, value) => {
    let { unCollapsed } = this.state;
    if (expand) {
      unCollapsed.push({ dc: dc, value: value });
    } else {
      unCollapsed = unCollapsed.filter(
        (x) => !(x.dc === dc && x.value === value)
      );
    }

    this.setState({ unCollapsed });
  };

  /**
   * Generate Recipient List UI
   * @returns 
   */
  recipientList = () => {
    const {
      groupOriginalRecipient,
      unCollapsed,
      searchTenantText,
      finalSelectedRecipient,
    } = this.state;
    let groupRecipient = [...(groupOriginalRecipient || [])];
    if (groupRecipient === undefined) {
      return <></>;
    }
    if (searchTenantText.length > 2) {
      groupRecipient = groupOriginalRecipient.filter(
        (xr) =>
          xr?.name?.toLowerCase()?.indexOf(searchTenantText?.toLowerCase()) >
          -1 ||
          xr?.tenantName
            ?.toLowerCase()
            ?.indexOf(searchTenantText?.toLowerCase()) > -1 ||
          xr?.userName
            ?.toLowerCase()
            ?.indexOf(searchTenantText?.toLowerCase()) > -1
      );
    }
    const checkboxes = [];
    if (this.state.communicationLogType !== "Customer Response") {
      this.getGroupedData(groupRecipient, "name")?.forEach((obj, i) => {
        checkboxes.push(
          <div className={"col-xs-12 parent-checkbox"}>
            <>
              {unCollapsed.find(
                (x) => x.dc === obj.value && x.value === obj.value
              ) ? (
                <ChevronDownIcon
                  fontSize={"small"}
                  onClick={() => {
                    this.handleCollapse(false, obj.value, obj.value);
                  }}
                />
              ) : (
                <ChevronRightIcon
                  fontSize={"small"}
                  onClick={() => {
                    this.handleCollapse(true, obj.value, obj.value);
                  }}
                />
              )}
            </>
            {((this.state.isViewOnly !== true || this.state.isReply === true) || this.state.isCreate === true) && (
              <Checkbox
                key={obj.key + i}
                className={"checkbox"}
                label={obj.value}
                checked={
                  (finalSelectedRecipient.filter((r) => r.name === obj.value)
                    ?.length || 0) === obj.data.length
                }
                onChange={(event) => {
                  this.handleRecipientChange(
                    "tenantName",
                    obj,
                    event,
                    obj.value,
                    obj
                  );
                }}
                labelPlacement={"end"}
              />
            )}
            <span
              className={
                "label recipient-name" +
                (finalSelectedRecipient.filter((r) => r.name === obj.value)
                  ?.length > 0
                  ? " bold-text"
                  : "")
              }
            >
              {obj.value +
                " (" +
                (
                  finalSelectedRecipient.filter((r) => r.name === obj.value)
                    ?.length || 0
                ).toString() +
                "/" +
                (obj?.data?.length ?? 0) +
                ")"}
            </span>
          </div>
        );
        {
          unCollapsed.find((x) => x.dc === obj.value && x.value === obj.value) &&
            this.getGroupedData(obj.data, "tenantName")?.forEach((ten, t) => {
              checkboxes.push(
                <div className={"col-xs-12 level-One-child"}>
                  <span>
                    {" "}
                    {unCollapsed.find(
                      (x) => x.dc === obj.value && x.value === ten.value
                    ) ? (
                      <ChevronDownIcon
                        fontSize={"small"}
                        onClick={() => {
                          this.handleCollapse(false, obj.value, ten.value);
                        }}
                      />
                    ) : (
                      <ChevronRightIcon
                        fontSize={"small"}
                        onClick={() => {
                          this.handleCollapse(true, obj.value, ten.value);
                        }}
                      />
                    )}
                  </span>
                  {((this.state.isViewOnly !== true || this.state.isReply === true) || this.state.isCreate === true) && (
                    <Checkbox
                      key={ten.key + i}
                      checked={
                        (finalSelectedRecipient.filter(
                          (r) =>
                            r.name === obj.value && r.tenantName === ten.value
                        )?.length || 0) === ten?.data?.length
                      }
                      className={"checkbox"}
                      label={obj.value}
                      labelPlacement={"end"}
                      onChange={(event) => {
                        this.handleRecipientChange(
                          "userName",
                          ten,
                          event,
                          obj.value,
                          obj,
                          ten
                        );
                      }}
                    />
                  )}
                  <span
                    className={
                      "label" +
                      (finalSelectedRecipient.filter(
                        (r) => r.tenantName === ten.value && r.name === obj.value
                      )?.length > 0
                        ? " bold-text"
                        : "")
                    }
                  >
                    {ten.value +
                      " (" +
                      (
                        finalSelectedRecipient.filter(
                          (r) =>
                            r.tenantName === ten.value && r.name === obj.value
                        )?.length || 0
                      ).toString() +
                      "/" +
                      (ten?.data?.length ?? 0) +
                      ")"}
                  </span>
                </div>
              );
              {
                unCollapsed.find(
                  (x) => x.dc === obj.value && x.value === ten.value
                ) &&
                  this.getGroupedData(ten.data, "userName")?.forEach((con) => {
                    con.data?.forEach((emailTenant) => 
                    {checkboxes.push(
                      <div className={"col-xs-12 level-two-child"}>
                        {((this.state.isViewOnly !== true || this.state.isReply === true) || this.state.isCreate === true) && (
                          <Checkbox
                            style={{
                              margTop: "-5px !important",
                              paddingTop: "0px !important",
                            }}
                            key={con.key + i + t}
                            className={"checkbox"}
                            label={con.value}
                            checked={
                              finalSelectedRecipient.find(
                                (jc) =>
                                  jc.email === emailTenant.email &&
                                  jc.tenantName === ten.value &&
                                  jc.name === obj.value
                              ) !== undefined
                            }
                            labelPlacement={"end"}
                            onChange={(event) => {
                              this.handleRecipientChange(
                                "tenantEmail",
                                con,
                                event,
                                obj.value,
                                obj,
                                ten,
                                emailTenant.email
                              );
                            }}
                          >
                            {con.key}
                          </Checkbox>
                        )}
                        <div className={"label"}>
                          <div>{con.value}</div>
                          <div className={"sub-label"}>{emailTenant.email}</div>
                        </div>
                      </div>
                    )}
                  )
                  });
              }
            });
        }
      });
    }
    else {
      checkboxes.push(<p style={{ width: "100%" }} key={"propsRequester"}>{this.state?.requesterEmailID}</p>)
    }
    return checkboxes;
  };

  /**
   * Call Back for getting Communication Html body
   * @param {*} content 
   */
  getHtmlChanges = (content) => {
    this.setState({ content });
  };

  /**
   * Update Subject State
   * @param {*} subject 
   */
  handleChange = (subject) => {
    this.setState({ subject: subject.target.value });
  };

  /**
   * Render tooltip on UI
   * @param {*} txtToolTip 
   * @param {*} isRequired 
   * @returns 
   */
  renderToolTip = (txtToolTip, isRequired = false) => {
    const toolTip = this.state.getToolTip?.find(
      (b) => b.UiColumnName == txtToolTip
    )?.Tooltip;
    return (
      <>
        {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
        {toolTip && (
          <Tooltip title={toolTip}>
            <IconButton size={"small"} className={"tooltip-iconSize"}>
              <InfoOutlined fontSize={"inherit"} />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };

  /**
   * Handles Attachment for communication 
   * @param {*} e 
   * @returns 
   */
  handleFileUpload = (e) => {
    const { formData, fileName, fileSize } = this.state;
    const files = e.target.files;
    const lstName = fileName;
    if (files && files.length) {
      const lstFiles = formData;
      let filesSize = fileSize;
      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 0) {
          filesSize = filesSize + files[i].size;
        }
        lstName.push(files[i].name);
        lstFiles.push(files[i]);
      }
      if (filesSize > maxFileSize && filesSize <= maxZipFileSize) {
        ShowToast(
          "File size exceeded maximum limit of 25 mb, file will be sent as zip.",
          toastType.INFO,
          5000,
          200

        );
      }
      else if (filesSize > maxZipFileSize) {
        this.setState({ fileName: lstName, formData: lstFiles, fileSize: filesSize });
        ShowToast(
          "File size exceeded maximum limit of 29mb, file will not be sent. Either reduce size or remove some file.",
          toastType.ERROR,
          5000,
          200

        );
        return;
      }
      this.setState({ fileName: lstName, formData: lstFiles, fileSize: filesSize });
    }
  };

  /**
   * Remove Attachment from state
   * @param {*} e 
   */
  deleteFile = (e) => {
    const {fileName,formData,reload} = this.state;
    const s = fileName.filter((item) => item !== e);
    const f = formData.filter((item) => item.name !== e);
    let fileSize = 0;

    for (let i = 0; i < f.length; i++) {
      if (f[i].size > 0) {
        fileSize = fileSize + f[i].size;
      }
    }

    this.setState({ fileSize: fileSize, fileName: s, formData: f, reload: !reload });
  };

  /**
   * this method is used to generate Reply content popup when user click on chip
   * @param {*} replyMsg 
   */
  generateRepliedContent = (replyMsg) => {

    const replyContent = (<>
      <div className={"row"}>
        <div className={"col-xs-8"}><p><b>{"Sent By: "}{replyMsg.requesterEmailID}</b></p></div>
        <div className={"col-xs-4 end-xs"}><p><b>{"Sent on: "}{convertToLocalDate(replyMsg.emailSentDateTime, "MM/DD/YYYY")}</b></p></div>
        {replyMsg.attachment == "Yes" && <div
          className={"row"}
                                         >
          <FileAttachments
            requestCode={replyMsg.communicationCode}
            setUploadFilesList={[]}
            isDownloadOnly
            uploadFiles={[]}
            showUploadBtn={false}
            downloadPermission
          />
                                         </div>}
      </div><div className={"row"}>
        <div className={"col-xs-12"}>
          <div className={"col-xs-12 reply-content"} dangerouslySetInnerHTML={{ __html: replyMsg.emailMessage || "" }} />
          {replyMsg.isInternalUser === 1 && <div className={"col-xs-12"}>
            <img
              src={"public/img/common/Stream-Data-Centers_Logo_BLUE.svg"}
              alt={"Stream Logo"}
              style={{ width: "100px", marginTop: "5px" }}
            />
                                            </div>}
        </div>
            </div>
                          </>);

    const replyContentTitle = replyMsg.emailSubject;
    this.setState({ isReplyContentOpen: true, replyContentTitle, replyContent });

  }
  /**
   * Render Communication UI
   * @returns 
   */
  render() {
    const { searchTenantText } = this.state;
    // const toolTipRecipient = this.state.getToolTip?.find(
    //   (b) => b.UiColumnName == "Recipients"
    // )?.Tooltip;
    // const toolTipSubject = this.state.getToolTip?.find(
    //   (b) => b.UiColumnName == "Subject"
    // )?.Tooltip;
    (this.state.isViewOnly !== true || this.state.isReply === true) && localStorage.setItem("IsInEditMode", 1)
    return (
      <div>
        <Dialog
          open={this.props.isOpen || false}
          onClose={() => this.props.onClose(false)}
          PaperComponent={PaperComponent}
          fullWidth
          fullScreen
          maxWidth={"lg"}
          className={"add-update-communication"}
        >
          <AppBar style={{ position: "relative", backgroundColor: "#064473" }}>
            <Toolbar>
              <Typography
                variant={"h6"}
                style={{ marginLeft: "15px", flex: "1" }}
              >
                {this.state.isViewOnly === true
                  ? (this.state.isReply === true ? "Reply " : "View ") + "Communication (" + this.state.commCode + ")"
                  : "Send Communication"}
              </Typography>
              <Tooltip title={"Close"}>
                <IconButton
                  title={"Close"}
                  edge={"end"}
                  color={"inherit"}
                  onClick={() => this.props.onClose(false)}
                  aria-label={"close"}
                  className={"white-button"}
                >
                  <IoMdCloseCircleOutline />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>

          <DialogContent>
            <Box
              component={"form"}
              border={0}
              borderColor={"grey.500"}
              borderRadius={1}
              noValidate
              autoComplete={"off"}
              className={"communication"}
            >
              <div className={"row"}>
                <div className={"col-xs-4"}>
                  <div className={"row"}>
                    <div className={(this.props.mainContent?.childData || []).length > 0 || this.state.isReply ? "col-xs-12 recipientBox " : "col-xs-12"}>
                      <div className={"col-xs-12 no-padding "}>
                        {/* Recipients {this.renderToolTip("Recipients", true)} */}
                        <div className={"col-xs-12 no-padding label-readonly"}>
                          <InputLabelWithToolTip
                            className={"compLabel"}
                            id={"RecipientsLabel"}
                            isRequired={!this.state.isViewOnly || this.state.isReply === true}
                            labelHeading={"Recipients"}
                            toolTip={
                              this.state.getToolTip?.find(
                                (b) => b.UiColumnName == "Recipients"
                              )?.Tooltip
                            }
                          />
                        </div>
                      </div>
                      <div className={"row recipient"}>
                        <TextField
                          id={"filled-required"}
                          fullWidth
                          disabled={this.state.communicationLogType === "Customer Response"}
                          className={"filterComp"}
                          label={"Name"}
                          value={searchTenantText}
                          onChange={(event) =>
                            this.setState({
                              searchTenantText: event.target.value,
                            })}
                          InputProps={{
                            endAdornment: (
                              this.state.communicationLogType !== "Customer Response" && <InputAdornment>
                                <IconButton>
                                  <SearchIcon />
                                </IconButton>
                                                                                         </InputAdornment>
                            ),
                          }}
                          inputProps={{
                            maxLength: 250,
                          }}
                        />

                        {this.recipientList()}
                      </div>
                    </div>
                    {((this.props.mainContent?.childData || []).length > 0 || this.state.isReply === true) &&
                      <div className={"row reply-box"}>
                        <div className={"col-xs-12 no-padding"}>
                          <div className={"col-xs-12 no-padding"} style={{ marginTop: "5px" }}>
                            <span />
                            <div className={"col-xs-12  no-padding label-readonly"}>
                              <InputLabelWithToolTip
                                className={"compLabel"}
                                id={"historyLabel"}
                                isRequired={false}
                                labelHeading={"Email History "}
                                toolTip={"Email History"}
                              />
                            </div>
                          </div>
                          {(this.state.isReply === true || this.state.communicationCode !== this.props.mainContent.communicationCode) &&
                            <> <span
                              className={"history-label"}
                              key={"chip" + this.props.mainContent.communicationCode + "c"}
                              onClick={() => { this.generateRepliedContent(this.props.mainContent); }}
                               > {this.props.mainContent.communicationCode}
                               </span>
                              {((this.props.mainContent?.childData || []).filter(com => com.communicationCode !== this.state.communicationCode)?.length > 0
                              ) &&
                                <span
                                  className={"history-label right-margin-5"}
                                  key={"comma_main" + "c"}
                                >{","}
                                </span>}
                            </>}

                          {(this.props.mainContent?.childData || []).map((replyMsg, i) => (
                            <>
                              {(this.state.reply === true || this.state.communicationCode !== replyMsg.communicationCode) && <><span
                                className={replyMsg.isInternalUser === 0 ? "customer-reply history-label" : "history-label"}
                                key={"chip" + i + "c"}
                                onClick={() => { this.generateRepliedContent(replyMsg); }}
                                                                                                                               >{replyMsg.communicationCode}
                                                                                                                               </span>
                                {(((this.props.mainContent?.childData || []).length > i + 1) &&
                                  (this.props.mainContent?.childData || [])[i + 1]?.communicationCode !== this.state.communicationCode ||
                                  (this.props.mainContent?.childData || []).length > i + 2) &&
                                  <span
                                    className={"history-label right-margin-5"}
                                    key={"comma" + i + "c"}
                                  >{","}
                                  </span>}
                                                                                                                             </>}
                            </>
                          ))}
                          <DialogModal
                            open={this.state.isReplyContentOpen || false}
                            className={"reply-child-content"}
                            title={this.state.replyContentTitle}
                            children={this.state.replyContent}
                            onClose={() => { this.setState({ isReplyContentOpen: false, replyContent: <></> }) }}
                          />
                        </div>
                      </div>}
                  </div>
                </div>
                <div className={"col-xs-8"}>
                  <div className={"row "}>
                    <div className={this.state.isViewOnly && this.state.isReply == false ? "col-xs-9" : "col-xs-12"}>
                      {(this.state.isViewOnly && this.state.isReply == false) ? <>
                        <div className={"col-xs-12 label-readonly"} style={{ paddingLeft: "5px" }}>
                          <InputLabelWithToolTip
                            className={"compLabel"}
                            id={"requestSubjectLabel"}
                            isRequired={!this.state.isViewOnly || this.state.isReply === true}
                            labelHeading={"Subject"}
                            toolTip={
                              this.state.getToolTip?.find(
                                (b) => b.UiColumnName == "Subject"
                              )?.Tooltip
                            }
                          />
                        </div>
                        <div className={"col-xs-12 border-bottom"}>{this.state.subject}</div>
                                                                                </>
                        : <TextFieldWithToolTip
                          id={"subject"}
                          isRequired={!this.state.isViewOnly || this.state.isReply === true}
                          disabled={this.state.isViewOnly && this.state.isReply === false}
                          value={this.state.subject || ""}
                          onChange={this.handleChange}
                          txtName={"subject"}
                          labelHeading={"Subject"}
                          toolTip={
                            this.state.getToolTip?.find(
                              (b) => b.UiColumnName == "Subject"
                            )?.Tooltip
                          }
                          />}
                    </div>

                    {this.state.isViewOnly == true && this.state.isReply == false &&
                      <div className={"col-xs-3 end-xs"}><p><b>{"Sent on: "}{convertToLocalDate(this.state?.emailSentDateTime, "MM/DD/YYYY")}</b></p></div>}

                    {(this.state.commCode !== null && (this.state.isReply || false) === false) && this.state.attachment == "Yes" && <div
                      className={"row"}
                                                                                                                                    >
                      <FileAttachments
                        requestCode={this.state.commCode}
                        setUploadFilesList={[]}
                        isDownloadOnly
                        uploadFiles={[]}
                        showUploadBtn={false}
                        downloadPermission
                      />
                                                                                                                                    </div>}
                    {(this.state.commCode == null || this.state.isReply === true) && <FileUpload
                      reload={this.state.reload}
                      onChange={this.handleFileUpload}
                      deleteFile={this.deleteFile}
                      fileName={this.state.fileName}
                      formData={this.state.formData}
                                                                                     />}
                    {(this.state.communicationLogType != "Customer Response") && <div className={"col-xs-12 content dear-text"}>
                      <label>{"Dear Tenant,"}</label>

                                                                                 </div>}
                    <div className={"col-xs-12"}>
                      {(this.state.isViewOnly && (this.state?.isReply || false) === false)
                        ? <div className={"col-xs-12 view-main-content"} dangerouslySetInnerHTML={{ __html: this.state.content || "" }} />
                        : <EditorConvertToHTML
                          disabled={this.state.isViewOnly && (this.state?.isReply || false) === false}
                          onChange={this.getHtmlChanges}
                          value={this.state.isReply == true ? "" : this.state.content || ""}
                          />}
                    </div>
                  </div>
                  <div className={"row"}>
                    <div className={"col-xs-12 content signature-text"}>
                      <div className={"content"}>
                        <label>{"Sincerely,"}</label>
                      </div>
                      <div>
                        <label>
                          {this.state.requesterEmailID && this.state.isReply === false
                            ? this.state.requesterEmailID
                            : GetUserName() || ""}
                        </label>
                        <div >
                          {(this.state.communicationLogType != "Customer Response" || this.state.isReply === true) && <img
                            src={"public/img/common/Stream-Data-Centers_Logo_BLUE.svg"}
                            alt={"Stream Logo"}
                            style={{ width: "100px" }}
                                                                                                                      />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Box>
          </DialogContent>
          <DialogActions >
            <Button
              autoFocus
              color={"primary"}
              onClick={() => this.props.onClose(false)}
            >
              {"Cancel\r"}
            </Button>
            {(this.state.isViewOnly !== true || this.state.isReply === true) && (
              <Button
                autoFocus
                color={"primary"}
                onClick={() => this.onSubmitConfirm()}
              >
                {"Send\r"}
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default AddUpdateCommunication;
